import React from 'react';
import { CardBody, Row, Col, FormGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FMessage } from '../../hoc/IntlComponents';
import SiteKeyBlock from './SiteKeyBlock';
import LandingApiRequestsGuide from './LandingApiRequestsGuide';

const LandingApiRequests = ({ type, tabProps: { api_key }, inProfile }) => (
  <CardBody className="landing-api-request">
    <SiteKeyBlock type={type} api_key={api_key} />
    {api_key && !inProfile && <LandingApiRequestsGuide />}
    {api_key && inProfile && <Row className='upd-api-btn'>
      <Col>
        <FormGroup>
          <Link
            to={{
              pathname: "/tickets/create",
              search: "?sitekey=update_key",
            }}
            className="btn btn-primary btn-md outline"
          >
            <FMessage id='transfer-by-api.sitekey.update.btn' />
          </Link>
        </FormGroup>
      </Col>
    </Row>}
  </CardBody>
);

export default LandingApiRequests;
